import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// Gentle retry on transient gateway errors (502/503/504) — these usually
// happen during the brief backend reload window. We retry up to 2 times
// (~800ms then ~1.6s) on idempotent GET requests only, so a normal
// hot-reload of the backend doesn't bubble up as a visible error to the
// user.
const TRANSIENT_GATEWAY_CODES = new Set([502, 503, 504]);
const MAX_GATEWAY_RETRIES = 2;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const cfg = error?.config;
    const status = error?.response?.status;
    const isNetworkError = !error?.response && error?.code !== "ERR_CANCELED";
    const method = (cfg?.method || "get").toLowerCase();
    if (
      cfg &&
      method === "get" &&
      (TRANSIENT_GATEWAY_CODES.has(status) || isNetworkError)
    ) {
      cfg.__retryCount = (cfg.__retryCount || 0) + 1;
      if (cfg.__retryCount <= MAX_GATEWAY_RETRIES) {
        const delay = 400 * cfg.__retryCount;
        await new Promise((res) => setTimeout(res, delay));
        return api(cfg);
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Hiba történt. Próbáld újra.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
